import { render, staticRenderFns } from "./QuestionsList.vue?vue&type=template&id=77ddfa99&scoped=true"
import script from "./QuestionsList.vue?vue&type=script&lang=js"
export * from "./QuestionsList.vue?vue&type=script&lang=js"
import style0 from "./QuestionsList.vue?vue&type=style&index=0&id=77ddfa99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ddfa99",
  null
  
)

export default component.exports